import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environment/environment';
import { firstValueFrom } from 'rxjs';
import JSZip from 'jszip';

@Injectable({
    providedIn: 'root'
})
export class LokalService {
    private http = inject(HttpClient);

    /**
     * 1. Call Lokal export API → get downloadUrl
     * 2. Download the ZIP from downloadUrl
     * 3. Unzip → extract JSON files
     * 4. Strip "lead." prefix and return translations keyed by language
     */
    async fetchTranslations(): Promise<Record<string, any> | null> {
        const config = environment.lokalConfig;

        const headers = new HttpHeaders({
            'x-app-id': config.appId,
            'x-api-key': config.apiKey
        });

        // Step 1: Get the downloadUrl
        const meta = await firstValueFrom(
            this.http.get<{ downloadUrl: string; version: number }>(config.apiUrl, { headers })
        );
        console.log('✅ Lokal Export Meta:', meta);

        // Step 2: Download the ZIP (headers required for download too)
        const zipBuffer = await firstValueFrom(
            this.http.get(meta.downloadUrl, { headers, responseType: 'arraybuffer' })
        );

        // Step 3: Unzip and extract all JSON files
        const zip = new JSZip();
        const content = await zip.loadAsync(zipBuffer);
        const translations: Record<string, any> = {};
        console.log('📦 ZIP contents:', Object.keys(content.files));

        for (const [filename, file] of Object.entries(content.files)) {
            if (filename.endsWith('.json') && !file.dir) {
                const text = await file.async('string');
                const lang = filename.replace(/^.*\//, '').replace('.json', '');
                const raw: Record<string, string> = JSON.parse(text);

                // Strip "lead." prefix so template keys like 'benefits_section' resolve correctly
                const stripped: Record<string, string> = {};
                for (const [k, v] of Object.entries(raw)) {
                    stripped[k.replace(/^lead\./, '')] = v;
                }

                translations[lang] = stripped;
                console.log(`📦 Loaded: ${lang} — ${Object.keys(stripped).length} keys`);
            }
        }

        return Object.keys(translations).length > 0 ? translations : null;
    }
}
